module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/event_tours-a9f8584f97f0752c7ef85ba3d1c9e028.jpg";